import React, { useState, useEffect } from 'react';
// styles
import useStyles from "./styles";
import { getMuiTheme } from "./styles";
import {useTheme} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import { pathOr } from "ramda";
import { Scrollbars } from 'react-custom-scrollbars';
import { MuiThemeProvider } from "@material-ui/core/styles";

function not(a, b) {
    return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
    return a.filter((value) => b.indexOf(value) !== -1);
}

function union(a, b) {
    return [...a, ...not(b, a)];
}

export default function TransferList({ columnChooser, setTransferListLeftColumns, setTransferListRightColumns }) {
    const classes = useStyles();
    const currentTheme = useTheme();
    const [checked, setChecked] = useState([]);
    const [left, setLeft] = useState(Object.keys(columnChooser.display_tabs.columns));
    const [right, setRight] = useState(Object.keys(columnChooser.hide_tabs.columns));
    const [leftValue, setLeftValue] = useState(columnChooser.display_tabs.columns);
    const [rightValue, setRightValue] = useState(columnChooser.hide_tabs.columns);


    const leftChecked = intersection(checked, left);
    const rightChecked = intersection(checked, right);

    useEffect(() => {
        setTransferListLeftColumns(left.join("|"))
        setTransferListRightColumns(right.join("|"))

    }, [left, right])

    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    const numberOfChecked = (items) => intersection(checked, items).length;

    const handleToggleAll = (items) => () => {
        if (numberOfChecked(items) === items.length) {
            setChecked(not(checked, items));
        } else {
            setChecked(union(checked, items));
        }
    };

    const handleCheckedRight = () => {
        setRight(right.concat(leftChecked));
        setLeft(not(left, leftChecked));
        setChecked(not(checked, leftChecked));
    };

    const handleCheckedLeft = () => {
        setLeft(left.concat(rightChecked));
        setRight(not(right, rightChecked));
        setChecked(not(checked, rightChecked));
    };

    const customList = (title, items) => (
        <Card>
            <CardHeader
                className={classes.cardHeader}
                avatar={
                    <Checkbox
                        onClick={handleToggleAll(items)}
                        checked={numberOfChecked(items) === items.length && items.length !== 0}
                        indeterminate={numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0}
                        disabled={items.length === 0}
                        inputProps={{ 'aria-label': 'all items selected' }}
                    />
                }
                title={title}
                subheader={`${numberOfChecked(items)}/${items.length} selected`}
            />
            <Divider />
            
            <List className={classes.list}  component="div" role="list">
                
                {items.map((value) => {
                    if (leftValue[value] || rightValue[value]) {
                        const labelId = `transfer-list-all-item-${value}-label`;

                        return (
                            
                            <ListItem key={value} className={classes.listItem} role="listitem" button onClick={handleToggle(value)}>
                                <ListItemIcon>
                                    <Checkbox
                                        checked={checked.indexOf(value) !== -1}
                                        tabIndex={-1}
                                        disableRipple
                                        inputProps={{ 'aria-labelledby': labelId }}
                                    />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={`${leftValue[value] || rightValue[value]}`} />
                            </ListItem>
                        );
                    }
                })}
                <ListItem />
            </List>
        </Card>
    );

    return (
        <MuiThemeProvider theme={getMuiTheme(currentTheme)}>
        <Grid container spacing={2} justify="center" alignItems="center" className={classes.root}>
            <Grid item><h4 classes={classes.listHeader}>	Display Columns</h4>{customList('Choices', left)}</Grid>
            <Grid item>
                <Grid container direction="column" alignItems="center">
                    <Button
                        variant="outlined"
                        size="small"
                        className={classes.button}
                        onClick={handleCheckedRight}
                        disabled={leftChecked.length === 0}
                        aria-label="move selected right"
                    >
                        &gt;
          </Button>
                    <Button
                        variant="outlined"
                        size="small"
                        className={classes.button}
                        onClick={handleCheckedLeft}
                        disabled={rightChecked.length === 0}
                        aria-label="move selected left"
                    >
                        &lt;
          </Button>
                </Grid>
            </Grid>
            <Grid item><h4 classes={classes.listHeader}>	Hide Columns</h4>{customList('Chosen', right)}</Grid>
        </Grid>
        </MuiThemeProvider>
    );
}
